import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { computed, PropType } from "vue";
import TreeItemInterface from "@/types/TreeItemInterface";
import TreeList from "@/components/common/TreeList.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  items: {
    type: Array as PropType<Array<TreeItemInterface>>,
  },
  activeId: {
    type: Number,
    required: true,
  },
  parentColumn: {
    type: String,
    default: "parent",
  },
},
  emits: ["select"],
  setup(__props, { emit }) {

const props = __props





const itemsTree = computed(() => {
  const nodes = (props.items ?? []).map((item) => ({
    ...item,
    children: [] as TreeItemInterface[],
  }));
  const nodesById = new Map<string, TreeItemInterface>(
    nodes.map((item) => [item.id, item])
  );

  const roots: TreeItemInterface[] = [];
  nodes.forEach((item) => {
    const parentId = (item as unknown as Record<string, unknown>)[
      props.parentColumn
    ];
    if (parentId == null) {
      roots.push(item);
      return;
    }

    if (typeof parentId === "string") {
      const parent = nodesById.get(parentId);
      parent?.children?.push(item);
    }
  });

  return roots;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(itemsTree), (item) => {
    return (_openBlock(), _createBlock(TreeList, {
      key: item.id,
      item: item,
      setParentId: () => {},
      "active-id": __props.activeId,
      onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('select', $event)))
    }, null, 8, ["item", "setParentId", "active-id"]))
  }), 128))
}
}

})